/* eslint-disable curly */
import React, { Component } from "react";
import {
  View,
  Text,
  Image,
  Alert,
  TextInput,
  TouchableOpacity,
  ImageBackground,
  ScrollView,
  KeyboardAvoidingView,
  Platform,
  Linking,
} from "react-native";
import { EventRegister } from "react-native-event-listeners";

import Icon from "react-native-vector-icons/FontAwesome";
import IconE from "react-native-vector-icons/Entypo";
import { StackActions, NavigationActions } from "react-navigation";

import styles from "./styles";
import ButtonConfirm from "../../components/ButtonConfirm";
import { atualizar } from "../../services/aluno-service";
import { getAluno, setAluno } from "../../services/auth-service";
import Loading from "../../components/Loading";
import { alert } from "../../utils/alerts";

class AdicionarRedeSocial extends Component {
  constructor(props) {
    super();
    this.state = {
      socialUser: "",
      confirmDisabled: true,
    };
  }

  handlerInput = (e) => {
    this.setState({
      socialUser: e,
      confirmDisabled: e.length > 3 ? false : true,
      loading: false,
    });
  };

  handlerSubmit = async () => {
    let target = this.props.navigation.getParam("target");

    this.setState({ ...this.state, loading: true });

    let aluno = await getAluno();
    const cameFromHome = this.props.navigation.getParam("cameFromHome");
    let alunoAtualizar = {
      cpf: aluno.cpf,
      [target.toLowerCase()]: this.state.socialUser,
    };
    try {
      const response = await atualizar(alunoAtualizar);

      if (!response.ok) {
        this.setState({ ...this.state, loading: false });

        const erro = await response.json();

        return alert("Ops...", erro.erro);
      }

      setAluno({ ...aluno, [target.toLowerCase()]: this.state.socialUser });

      this.setState({ ...this.state, loading: false });

      if (!cameFromHome) {
        EventRegister.emit("reloadRedesSociais", "it works!!!");
        return this.props.navigation.pop();
      }

      const navigateAction = StackActions.reset({
        index: 0,
        actions: [NavigationActions.navigate({ routeName: "SignedIn" })],
      });

      this.props.navigation.dispatch(navigateAction);
    } catch (e) {
      console.log(e);
    }
  };

  handleDelete = async () => {
    let target = this.props.navigation.getParam("target");

    this.setState({ ...this.state, loading: true });
    console.log("passou");

    let aluno = await getAluno();
    const cameFromHome = this.props.navigation.getParam("cameFromHome");
    let alunoAtualizar = {
      cpf: aluno.cpf,
      [target.toLowerCase()]: null,
    };
    try {
      const response = await atualizar(alunoAtualizar);

      if (!response.ok) {
        this.setState({ ...this.state, loading: false });

        const erro = await response.json();

        return alert("Ops...", erro.erro);
      }

      setAluno({ ...aluno, [target.toLowerCase()]: "" });

      this.setState({ ...this.state, loading: false });

      if (!cameFromHome) {
        EventRegister.emit("reloadRedesSociais", "it works!!!");
        EventRegister.emit("reloadHome", "it works!!!");
        return this.props.navigation.pop();
      }

      const navigateAction = StackActions.reset({
        index: 0,
        actions: [NavigationActions.navigate({ routeName: "SignedIn" })],
      });

      this.props.navigation.dispatch(navigateAction);
    } catch (e) {
      console.log(e);
    }
  };

  dicas = {
    facebook: `Abra o aplicativo do Facebook \n Acesse seu perfil \n Clique em ... \n Role a tela até em baixo \n Clique em "Copiar link" \n Cole o link aqui `,
    instagram: `Abra o aplicativo do Instagram \n Acesse seu perfil \n Abra uma foto qualquer sua \n Clique nos três pontinhos \n Clique em Copiar Link \n Cole o link aqui`,
    linkedin: `Abra o Linkedin pelo navegador \n Acesso seu perfil \n Copie o link da barra de endereços \n Cole o link aqui`,
  };

  render() {
    const target = this.props.navigation.getParam("target");
    return (
      <>
        {this.state.loading && <Loading />}
        <KeyboardAvoidingView
          style={styles.container}
          behavior={this.isIos ? "padding" : "height"}
          enabled
        >
          <ImageBackground
            source={require("../../../resources/imgs/bg.jpg")}
            style={[styles.container]}
            imageStyle={styles.imageContainer}
          >
            <ScrollView
              style={{ width: "100%" }}
              contentContainerStyle={[styles.containerForm]}
            >
              <TouchableOpacity
                style={styles.iconClose}
                onPress={() => this.props.navigation.pop(1)}
              >
                <Icon name={"close"} size={30} color="#FFF" />
              </TouchableOpacity>
              <Text style={styles.textHeader1}>Cole o link do seu perfil</Text>
              <View
                style={{
                  width: "90%",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name={
                    target === "Facebook"
                      ? "facebook-square"
                      : target === "linkedin"
                      ? "linkedin-square"
                      : target.toLowerCase()
                  }
                  size={35}
                  // style={{ marginRight:  }}
                  color="#fff"
                />
                <TextInput
                  style={[
                    styles.input,
                    {
                      flex: 1,
                      textAlign: "left",
                      paddingStart: 10,
                      fontSize: 25,
                    },
                  ]}
                  placeholder={`https://www.${target.toLowerCase()}.com.br/...`}
                  placeholderTextColor="#ccc"
                  multiline={true}
                  autoCapitalize="none"
                  autoFocus={true}
                  value={this.state.socialUser}
                  onChangeText={this.handlerInput}
                />
              </View>
              <TouchableOpacity
                style={{ marginTop: 20, alignItems: "center" }}
                onPress={() => {
                  alert(
                    "Dica",
                    target === "Facebook"
                      ? this.dicas.facebook
                      : target === "linkedin"
                      ? this.dicas.linkedin
                      : this.dicas.instagram
                  );
                }}
              >
                <IconE
                  name="help-with-circle"
                  size={35}
                  // style={{ marginRight:  }}
                  color="#DDD"
                />
                <Text style={{ color: "#DDD", marginTop: 5 }}>
                  Precisa de ajuda?
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={{ marginTop: 30, alignItems: "center" }}
                onPress={() => {
                  if (
                    Platform.OS === "web" &&
                    window.confirm(
                      "Deseja realmente dispensar essa oportunidade?"
                    )
                  )
                    this.handleDelete;
                  else
                    Alert.alert(
                      "Confirma exclusão?",
                      `Deseja realmente exlcuir seu link com o ${target}`,
                      [
                        {
                          text: "SIM",
                          onPress: this.handleDelete,
                          style: "default",
                        },
                        {
                          text: "Cancelar",
                          onPress: () => {},
                          style: "cancel",
                        },
                      ]
                    );
                }}
              >
                <IconE
                  name="trash"
                  size={35}
                  // style={{ marginRight:  }}
                  color="#DDD"
                />
                <Text style={{ color: "#DDD", marginTop: 5 }}>
                  Excluir meu link com o {target}
                </Text>
              </TouchableOpacity>
              <ButtonConfirm
                text="Continuar"
                disabled={this.state.confirmDisabled}
                onPress={this.handlerSubmit}
                msgDisabled="Por favor, preencha um link válido."
              />
            </ScrollView>
          </ImageBackground>
        </KeyboardAvoidingView>
      </>
    );
  }
}

export default AdicionarRedeSocial;
